import { render } from "./adminHeader.vue?vue&type=template&id=2b56b29f&ts=true"
import script from "./adminHeader.vue?vue&type=script&lang=ts"
export * from "./adminHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__